import { ModuleWithProviders, NgModule } from '@angular/core';

import {
  CoreWebsocketService,
  DEFAULT_OPTIONS,
  defaultOptions,
  NEW_OPTIONS,
  NoopRequestErrorHandler,
  NoopTokenService,
  REQUEST_ERROR_HANDLER,
  TOKEN_SERVICE,
  WebsocketsModuleConfig,
  WebsocketsOptions,
} from './core';
import { WebsocketDispatcherService } from './websocket-dispatcher.service';

export function _configFactory(
  defaultOpts: WebsocketsOptions,
  newOpts: WebsocketsOptions | (() => WebsocketsOptions),
): (() => WebsocketsOptions) | WebsocketsOptions {
  return typeof newOpts === 'function' ? newOpts() : { ...defaultOpts, ...newOpts };
}

@NgModule({
  providers: [NoopTokenService, NoopRequestErrorHandler],
})
export class SntWebsocketsModule {
  static forRoot(config?: WebsocketsModuleConfig): ModuleWithProviders<SntWebsocketsModule> {
    return {
      ngModule: SntWebsocketsModule,
      providers: [
        CoreWebsocketService,
        {
          provide: NEW_OPTIONS,
          useValue: config?.options,
        },
        {
          provide: DEFAULT_OPTIONS,
          useValue: defaultOptions,
        },
        {
          provide: WebsocketsOptions,
          useFactory: _configFactory,
          deps: [DEFAULT_OPTIONS, NEW_OPTIONS],
        },
        {
          provide: TOKEN_SERVICE,
          useExisting: config ? config.tokenService : NoopTokenService,
        },
        {
          provide: REQUEST_ERROR_HANDLER,
          useExisting: config ? config.requestErrorHandler || NoopRequestErrorHandler : NoopRequestErrorHandler,
        },
        WebsocketDispatcherService,
      ],
    };
  }
}
